import { MutableRefObject, SetStateAction } from 'react';
import i18next from 'i18next';
import ILoadListData from '../interfaces/loads/ILoadListData';

function cardCantBeClicked(
    checkBoxRef: HTMLInputElement,
    event: any,
    numberOfSelectedCards: number,
): boolean {
    return (
        numberOfSelectedCards < 1 ||
        !checkBoxRef ||
        event.target.classList.contains('checkmark') ||
        event.target.classList.contains('checkbox') ||
        event.target.classList.contains('button')
    );
}

export function clickCard(
    checkBoxRef: HTMLInputElement,
    event: any,
    numberOfSelectedCards: number,
): void {
    if (cardCantBeClicked(checkBoxRef, event, numberOfSelectedCards)) {
        return;
    }

    checkBoxRef.click();
}

export function selectCard(data: {
    numberOfSelectedCards: MutableRefObject<number>;
    selectionLimit: number;
    loadId: string;
    setLoadList: (value: SetStateAction<ILoadListData[]>) => void;
    setToast: any;
}): void {
    if (data.numberOfSelectedCards.current < data.selectionLimit) {
        data.numberOfSelectedCards.current += 1;
        data.setLoadList(prevItems =>
            prevItems.map((item: ILoadListData) =>
                item.loadId === data.loadId
                    ? {
                          ...item,
                          checked: true,
                      }
                    : item,
            ),
        );

        return;
    }

    data.setToast(
        'warning',
        i18next.t('Atencao'),
        i18next.t('Loads.LimiteLoadsSeleconadas'),
    );
}

export function unselectCard(data: {
    numberOfSelectedCards: MutableRefObject<number>;
    loadId: string;
    setLoadList: (value: SetStateAction<ILoadListData[]>) => void;
}): void {
    data.setLoadList(prevItems =>
        prevItems.map((item: ILoadListData) =>
            item.loadId === data.loadId
                ? {
                      ...item,
                      checked: false,
                  }
                : item,
        ),
    );

    if (data.numberOfSelectedCards.current > 0)
        data.numberOfSelectedCards.current -= 1;
}
